<ng-container *ngIf="!!get && !!customerForm && !!deliveryForm && !!invoiceForm">
    <tt-tabs #tabs>
        <tt-tab ttId="address" ttLabel="orderhead_stat_address"></tt-tab>
        <tt-tab ttId="delivery" ttLabel="orderhead_delivery_address"></tt-tab>
        <tt-tab ttId="invoice" ttLabel="orderhead_invoice_address"></tt-tab>
    </tt-tabs>

    <tt-order-head-customer-address-form
        [hidden]="tabs.ttSelectedId !== 'address'"
        [get]="get"
        [form]="customerForm"
        [customerPersons]="customerPersons"
        [businesses]="businesses"
        [coops]="coops"
    ></tt-order-head-customer-address-form>
    <tt-order-head-delivery-address-form
        [hidden]="tabs.ttSelectedId !== 'delivery'"
        [get]="get"
        [form]="deliveryForm"
        [countries]="countries"
        [businesses]="businesses"
        [coops]="coops"
    ></tt-order-head-delivery-address-form>
    <tt-order-head-invoice-address-form
        [hidden]="tabs.ttSelectedId !== 'invoice'"
        [get]="get"
        [form]="invoiceForm"
        [businesses]="businesses"
        [coops]="coops"
    ></tt-order-head-invoice-address-form>
</ng-container>
